<sdps-divider class="condensed-divider" variation="secondary"></sdps-divider>
<div id="subtitle">Client authorization details</div>
<div class="label-group">
    <label class="label">{{labels.accountDetails}}</label>
    <div class="row">
        <div class="column" *ngFor="let authorizor of authorizors">
            <div class="data">{{authorizor['name'] | name}}</div>
            <div class="data">{{authorizor['email']}}</div>
        </div>
    </div>
</div>